import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import satyamAvatar from '../assets/images/satyam_avatar.png';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="about-hero">
          <div className="image-wrapper">
            <img src={satyamAvatar} alt="Satyam Gupta" />
          </div>
          <div className="content">
            <div className="social_icons">
              <a href="https://github.com/Satyamgupta2365" target="_blank" rel="noreferrer"><GitHubIcon/></a>
              <a href="https://linkedin.com/in/satyam-gupta-41606a28a" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            </div>
            <h1>Satyam Gupta</h1>
            <p>Software Development Engineer | AI/ML & SDE Builder</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;